export const ERROR_BOUNDARY_COPY = {
  title: 'Something went wrong',
  description:
    'We ran into an unexpected issue while loading this page. Please try again.',
  retryLabel: 'Try again',
} as const;

export const ERROR_BOUNDARY_LOG_ACTION =
  'Application render error captured by error boundary';
export const ERROR_BOUNDARY_LOG_CODE = 'global';
